import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../contexts/auth-context";

interface ProtectedRouteWrapperProps {
  component: React.ComponentType<any>;
  layout: React.ComponentType<any>;
  exact?: boolean;
  path: string;
}

export const ProtectedRouteWrapper: React.FC<ProtectedRouteWrapperProps> = ({
  component: Component,
  layout: Layout,
  ...rest
}) => {
  const { isLoggedIn } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect
            to={{
              pathname: "/prijava",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
